export default "__VITE_PUBLIC_ASSET__46a9ac7f__"